import { c2c } from "./solutions/c2c";
import { ibd } from "./solutions/ibd";
import { ibd_cc } from "./solutions/ibd_cc";
import { obdcc } from "./solutions/obd_cc";

export const C2C_CONSTANTS = {
  WINDOW_STATE_OPENED: "WINDOW_STATE",
  WINDOW_STATE_CLOSED: "WINDOW_STATE_CLOSED",
  WINDOW_STATE_MINIMIZED: "WINDOW_STATE_MINIMIZED",

  WIDGET_TYPE_BROWSER_WINDOW: "WIDGET_TYPE_BROWSER_WINDOW",
  WIDGET_TYPE_PAGE_WIDGET: "WIDGET_TYPE_PAGE_WIDGET",

  CALL_TYPE_PHONE: "CALL_TYPE_PHONE",
  CALL_TYPE_WEBRTC: "CALL_TYPE_WEBRTC",

  C2C_STATE_NONE: "C2C_STATE_NONE",
  C2C_STATE_C2C_FORM_INPUT: "C2C_STATE_C2C_FORM_INPUT",
  C2C_STATE_C2C_INBOUND_CALL: "C2C_STATE_C2C_INBOUND_CALL",
  C2C_STATE_C2C_OUTBOUND_CALL: "C2C_STATE_C2C_OUTBOUND_CALL",

  //Call Transfer states
  C2C_STATE_CALL_TRANSFER_FORM_INPUT: "C2C_STATE_CALL_TRANSFER_FORM_INPUT",
  C2C_STATE_CALL_TRANSFER_IN_PROGRESS: "C2C_STATE_CALL_TRANSFER_IN_PROGRESS",
  C2C_STATE_CALL_TRANSFER_SUCCESS: "C2C_STATE_CALL_TRANSFER_SUCCESS",
  C2C_STATE_CALL_TRANSFER_ERROR: "C2C_STATE_CALL_TRANSFER_ERROR",
  C2C_STATE_CALL_TRANSFER_TIMEOUT: "C2C_STATE_CALL_TRANSFER_TIMEOUT",

  //Call Confereence states
  C2C_STATE_CALL_CONF_FORM_INPUT: "C2C_STATE_CALL_CONF_FORM_INPUT",
  C2C_STATE_CALL_CONF_IN_PROGRESS: "C2C_STATE_CALL_CONF_IN_PROGRESS",
  C2C_STATE_CALL_CONF_SUCCESS: "C2C_STATE_CALL_CONF_SUCCESS",
  C2C_STATE_CALL_CONF_ERROR: "C2C_STATE_CALL_CONF_ERROR",
  C2C_STATE_CALL_CONF_TIMEOUT: "C2C_STATE_CALL_CONF_TIMEOUT",

  // Call Transfer Type
  CALL_TRANSFER_TYPE_TRANSFER: "CALL_TRANSFER_TYPE_TRANSFER",
  CALL_TRANSFER_TYPE_CONFERENCE: "CALL_TRANSFER_TYPE_CONFERENCE",

  //Events
  EVENT_C2C_CALL_START: "EVENT_C2C_CALL_START",
  EVENT_C2C_CALL_INPROGRESS: "EVENT_C2C_CALL_INPROGRESS",
  EVENT_C2C_CALL_COMPLETED: "EVENT_C2C_CALL_COMPLETED",
  EVENT_C2C_CALL_HANGUP_START: "EVENT_C2C_CALL_HANGUP_START",
  EVENT_C2C_CALL_HANGUP_INPROGRESS: "EVENT_C2C_CALL_HANGUP_INPROGRESS",
  EVENT_C2C_CALL_HANGUP_COMPLETE: "EVENT_C2C_CALL_HANGUP_COMPLETE",
  EVENT_C2C_CALL_TRANSFER_CLICKED: "EVENT_C2C_CALL_TRANSFER_CLICKED",
};

export const CALL_COMMANDS = {
  MUTE: "MUTE",
  HOLD: "HOLD",
  CALL_PROGRESS: "CALL_PROGRESS",
  DIALPAD: 'DIALPAD'
};

export const MUTE_STATES = {
  ON_MUTE: "ON_MUTE",
  NOT_ON_MUTE: "NOT_ON_MUTE",
};
export const HOLD_STATES = {
  ON_HOLD: "ON_HOLD",
  ON_UNHOLD: "NOT_ON_HOLD",
};

export const CALL_PROGRESS_STATES = {
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
};

export const DIALPAD_STATE = {
  DIALPAD_OPENED: 'DIALPAD_OPENED',
  DIALPAD_CLOSED: 'DIALPAD_CLOSED'
}

export const MESSAGES = {
  ERR_TRANSFER: "Error transfering call",
  ERR_TRANSFER_CANCEL: "Error transfering cancel",
  ERR_CONF_TRANSFER: "Error transfering call",
  ERR_CONF_TRANSFER_CANCEL: "Error transfering cancel",
  ERR_TRANSFER_MERGE: "Error transfering merge call",
  ERR_QUEUE_TRANSFER: "Error transfering queue",
};

export const CALL_SOLUTIONS = {
  c2c: c2c,
  inbound_cc: ibd_cc, // IBD CC
  obdcc: obdcc, //OBD CC
  inbound_noncc: ibd, //IBD Non-Call Center
};

export const CALL_VIEW_STATES = {
  CALL_VIEW_INITIAL: "CALL_VIEW_INITIAL",
  CALL_VIEW: "CALL_VIEW",
  CALL_DIALPAD: 'CALL_DIALPAD',
  CALL_ADD_CUSTOMER: "CALL_ADD_CUSTOMER",
  CALL_ADD_TRANSFER_VIEW: "CALL_ADD_TRANSFER_VIEW",
  CALL_ADD_CONFERENCE_VIEW: "CALL_ADD_CONFERENCE_VIEW",
  CALL_CONFERENCE_INITIATED_VIEW: "CALL_CONFERENCE_INITIATED_VIEW",
  CALL_CONFERENCE_CONNECTED_VIEW: "CALL_CONFERENCE_CONNECTED_VIEW",
  CALL_VIEW_MINIMIZED_VIEW: "CALL_VIEW_MINIMIZED",
  CALL_TRANSFER_INITIATED_VIEW: "CALL_TRANSFER_INITIATED_VIEW",
  CALL_TRANSFER_CONNECTED_VIEW: "CALL_TRANSFER_CONNECTED_VIEW",
  CALL_TRANSFER_COMPLETED_VIEW: "CALL_TRANSFER_COMPLETED_VIEW",
  CALL_TRANSFER_TO_QUEUE_COMPLETED_VIEW:
    "CALL_TRANSFER_TO_QUEUE_COMPLETED_VIEW",
};

export const CALL_STATES = {
  CALL_NONE: "CALL_NONE",
  CALL_INITIATED: "CALL_INITIATED",
  CALL_CONNECTED: "CALL_CONNECTED",
  CALL_HANGUP: "CALL_HANGUP",
  CALL_WRAPUP: "CALL_WRAPUP",
};

export const MOCK_EVENTS = {
  AGENT_CALL: {
    event_type: "AGENT_CALL",
    business_call_type: "Unanswered",
    agent_number: "+918076612543",
    call_recording: null,
    knowlarity_number: "+911141258316",
    uuid: "648267f8-2b6a-43a1-9c3c-dad1f03fa5d1",
    call_direction: "Outbound",
    caller: "+100000000000",
    customer_number: "+919651860999",
    version: "1.0",
    k_number: "+911141258316",
    type: "AGENT_CALL",
    unique_id: "648267f8-2b6a-43a1-9c3c-dad1f03fa5d1_0",
    call_solution: "c2c",
    FreeSWITCH_IPv4: "10.0.0.165",
    Event_Date_Local: "2021-10-07 17:45:45",
    Channel_Name: "sofia/external/09452960632",
    variable_ivr_refnum: "1000054473",
    m_fsrt_ssert: 127,
    m_ssert_ssest: 0,
  },
  CUSTOMER_ANSWER: {
    event_type: "CUSTOMER_ANSWER",
    business_call_type: "Outbound",
    agent_number: "+919452960632",
    call_recording: null,
    knowlarity_number: "+911141258316",
    uuid: "648267f8-2b6a-43a1-9c3c-dad1f03fa5d1",
    call_direction: "Outbound",
    caller: "+918802900919",
    customer_number: "+919651860999",
    version: "1.0",
    k_number: "+911141258316",
    type: "CUSTOMER_ANSWER",
    unique_id: "deec3b4d-cc08-45d3-a5bc-32d875e2e546",
    call_solution: "c2c",
    FreeSWITCH_IPv4: "10.0.0.165",
    Event_Date_Local: "2021-10-07 17:46:06",
    Channel_Name: "sofia/external/08802900919",
    variable_ivr_refnum: "1000054473",
    m_fsrt_ssert: 128,
    m_ssert_ssest: 0,
  },
};

export const TICKER_MODE = "mock1";
export const TICKER_DEBUG_PANEL = false;

export const ANALYTICS = {
  MODULE_TITLE: "Click to Call",

  C2CWidgetClick_LEFT_NAV: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Left Navigation",
  ],
  C2CWidgetClick_LEFT_AGENT_DB: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Agent Dashboard",
  ],
  C2CWidgetClick_LEFT_CALL_LOGS: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Call Logs",
  ],
  C2CWidgetClick_LEFT_SMS_LOGS: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "SMS Logs",
  ],
  C2CWidgetClick_LEFT_CRM_HOME: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Customer Management Home Screen",
  ],
  C2CWidgetClick_LEFT_CRM_CUSTOMER: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Customer Screen",
  ],
  C2C_CALL_SUBMIT: [
    "Click to Call",
    "C2C Call Submit",
    "C2C Call",
    "C2C Call Initiate",
  ],
  C2C_ADD_CUST: [
    "Live Call Ticker (LCT)",
    "Add/Update Click LCT",
    "Add/Update Customer Click LCT",
    "Add/Update",
  ],
  C2C_CALL_TRANSFER: [
    "Live Call Ticker (LCT)",
    "Call Transfer Click LCT",
    "Call Transfer LCT",
    "Call Transfer",
  ],
  C2C_CALL_CONF: [
    "Live Call Ticker (LCT)",
    "Call Conference Click LCT",
    "Call Conference LCT",
    "Call Conference",
  ],
  C2C_VIEW_HIST: [
    "Live Call Ticker (LCT)",
    "View History Click LCT",
    "View History LCT",
    "View History",
  ],
  C2C_HOLD: ["Live Call Ticker (LCT)", "Hold LCT", "", ""],
  C2C_MUTE: ["Live Call Ticker (LCT)", "Mute LCT", "", ""],
  C2C_CUST_SUBMIT: [
    "Live Call Ticker (LCT)",
    "Add/Update Submit LCT",
    "Add/Update Customer Submit LCT",
    "Add/Update",
  ],
  C2C_CUST_BACK: [
    "Live Call Ticker (LCT)",
    "Add/Update Back LCT",
    "Add/Update Customer Back LCT",
    "Add/Update Back",
  ],
  C2CWidgetClick_CALL_LOGS: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Call Logs",
  ],
  C2CWidgetClick_SMS_LOGS: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "SMS Logs",
  ],
  C2CWidgetClick_CRM: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "CRM",
  ],
  C2CWidgetClick_AGENT_DB: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Agent Dashboard",
  ],
  AGENT_DB_MAC_CLICK: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Click",
  ],
  AGENT_DB_MAC_SAVE: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Mark as complete",
  ],
  AGENT_DB_MAC_CANCEL: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Cancel",
  ],
  AGENT_DB_MAC_CLOSE_WINDOW: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Close Window",
  ],
  AGENT_DB_RF_CLICK: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Click",
  ],
  AGENT_DB_RF_SAVE: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Mark as complete",
  ],
  AGENT_DB_RF_CANCEL: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Cancel",
  ],
  AGENT_DB_RF_CLOSE_WINDOW: [
    "Dashboard - Agent",
    "Mark as Complete Click",
    "Mark as Complete",
    "Close Window",
  ],
};